import { Injectable, signal } from '@angular/core';

/**
 * The settings tab currently shown, for navigation outside the settings page
 * (the mobile menu). The URL alone isn't enough: without a `tab` param the page
 * picks the landing tab by role. Null while the settings page isn't open.
 */
@Injectable({ providedIn: 'root' })
export class SettingsNavStateService {
  readonly activeParam = signal<string | null>(null);
}
